var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighlightedMenuIcon2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "6px",
    viewBox: "0 0 20 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0126E6F1-76CB-44B7-AE48-D7C3CB925C78") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Admin-Settings-List-View",
    transform: "translate(-1272.000000, -665.000000)",
    fill: "#0091FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1282.37441,672.922358 C1283.62082,672.922358 1284.63124,673.932774 1284.63124,675.179186 C1284.63124,676.425597 1283.62082,677.436014 1282.37441,677.436014 C1281.128,677.436014 1280.11759,676.425597 1280.11759,675.179186 C1280.11759,673.932774 1281.128,672.922358 1282.37441,672.922358 Z M1282.37441,665.632358 C1283.62082,665.632358 1284.63124,666.642774 1284.63124,667.889186 C1284.63124,669.135597 1283.62082,670.146014 1282.37441,670.146014 C1281.128,670.146014 1280.11759,669.135597 1280.11759,667.889186 C1280.11759,666.642774 1281.128,665.632358 1282.37441,665.632358 Z M1282.37441,658.342358 C1283.62082,658.342358 1284.63124,659.352774 1284.63124,660.599186 C1284.63124,661.845597 1283.62082,662.856014 1282.37441,662.856014 C1281.128,662.856014 1280.11759,661.845597 1280.11759,660.599186 C1280.11759,659.352774 1281.128,658.342358 1282.37441,658.342358 Z",
    id: "Highlighted-Menu-Icon",
    transform: "translate(1282.374413, 667.889186) rotate(90.000000) translate(-1282.374413, -667.889186) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlightedMenuIcon2);
export default __webpack_public_path__ + "static/media/highlightedMenuIcon2.9389c3f1bad7109a1795f04d8de85f32.svg";
export { ForwardRef as ReactComponent };